import React from 'react';
import { Row, Col } from 'react-bootstrap'
import ElementFactory from '../elements/ElementFactory'

export const createElement = (element) => {
  return (
    <Row key={Math.random()}>
      {element.content.map((child, i) => (
        <Col key={Math.random()} xs={12} md={12} lg={child.size}>
          {ElementFactory.create(child.type, child)}
        </Col>
      ))}
    </Row>
  )
}